import { PrintText, PrintTitle, SpaceLine } from 'components/print'
import { PrintRichText } from 'components/print/components/PrintRichText'
import { Municipio, TipoAtestadoEnum } from 'graphql/types.generated'
import moment from 'moment'
import React from 'react'

import { PrintAtestadoLegado } from './PrintAtestadoLegado'

interface ImpressaoAtestadoProps {
  tipoAtestado: TipoAtestadoEnum
  content: string
  municipio?: Partial<Municipio>
  dataAtendimento?: Instant
}

export const ImpressaoAtestado = (props: ImpressaoAtestadoProps) => {
  const { tipoAtestado, content, dataAtendimento, municipio } = props
  const title = tipoAtestado === TipoAtestadoEnum.LICENCA_MATERNIDADE ? 'Licença maternidade' : 'Atestado'

  return (
    <>
      {!tipoAtestado ? (
        <PrintAtestadoLegado textStyles={{ marginLeft: '24px', marginRight: '24px' }} content={content} />
      ) : (
        <>
          <PrintTitle title={title} level={3} transform='capitalize' />
          <SpaceLine />
          <PrintRichText textStyles={{ marginLeft: '24px', marginRight: '24px' }} content={content} />
        </>
      )}

      <PrintText
        wrapperStyles={{
          marginTop: '100px',
          marginRight: '32px',
          alignSelf: 'flex-end',
        }}
        textStyles={{ fontSize: 10 }}
      >
        {municipio.uf.sigla +
          ' - ' +
          municipio.nome[0] +
          municipio.nome.substr(1).toLocaleLowerCase() +
          ', ' +
          moment(dataAtendimento).format('DD [de] MMMM [de] YYYY').toLowerCase() +
          '.'}
      </PrintText>
    </>
  )
}
